import { Flex } from '@radix-ui/themes'
import { Checkbox } from '@/components/ui/checkbox'
import { Input } from '@/components/ui/input'

const AnserItem = ({
  checked,
  answer,
  isEditing = false,
  onAnswerChange,
  onCheckedChange,
}: {
  checked: boolean
  answer: string
  isEditing?: boolean
  onAnswerChange?: (newAnswer: string) => void
  onCheckedChange?: (checked: boolean) => void
}) => {
  const isAnswerValid = answer.trim().length > 0
  const showError = !isAnswerValid && answer.length > 0

  return (
    <div>
      <Flex align={'center'} gap={'12px'}>
        <Checkbox
          checked={checked}
          color='#0057B8'
          onCheckedChange={isEditing ? onCheckedChange : undefined}
          disabled={!isEditing}
        ></Checkbox>
        {isEditing ? (
          <div className='flex-1'>
            <Input
              value={answer}
              onChange={(e) => onAnswerChange?.(e.target.value)}
              className={`font-light ${
                showError ? 'border-red-500 focus:border-red-500' : ''
              }`}
            />
            {showError && (
              <p className='mt-1 text-xs text-red-500'>
                Answer option cannot be blank
              </p>
            )}
          </div>
        ) : (
          <p className='font-light'>{answer}</p>
        )}
      </Flex>
    </div>
  )
}

export default AnserItem
